const FLAG_SRC: Record<string, string> = {
  en: '/images/flags/gb.svg',
  fr: '/images/flags/fr.svg',
  de: '/images/flags/de.svg',
  es: '/images/flags/es.svg',
  zh: '/images/flags/cn.svg',
  km: '/images/flags/kh.svg',
  vi: '/images/flags/vn.svg',
}

export function Flag({ code, className = 'h-4 w-6' }: { code: string; className?: string }) {
  const src = FLAG_SRC[code]
  if (!src) return null
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className={`fb-flag ${className} shrink-0 rounded-[2px] object-cover`}
    />
  )
}
